import './App.css';

const Form = () => {
    return (
        <section className='form-div'>
            <h6>35,000+ ALREADY JOINED</h6>
            <h1>Stay up-to-date what we're doing</h1>

            <form action="">
                <input type="text" placeholder='Enter your email address' />
                <button className="loginButton">
                    Contact Us
                </button>
            </form>
        </section>
    );
}

export default Form;